import React from "react";
import ReactDOM from "react-dom";
import HexModal from "../../../app/components/modals/HexModal";

import RemoveBenefitsModal from "../../../app/components/modals/benefits/RemoveBenefitsModal";
import { showErrorMessage } from "../../commons/show-error-message";

import { addContextLog } from "../../../infrastructure/log";
import { translate } from "../../../infrastructure/translate/localization";

function renderDeleteBenefitModal(benefit) {
  ReactDOM.render(
    <HexModal>
      <RemoveBenefitsModal
        benefitName={benefit.name}
        benefitModalId={benefit.id}
      />
    </HexModal>,
    document.getElementById("modal-container")
  );
}

export async function displayDeleteBenefitModal(benefit) {
  try {
    addContextLog(
      "info",
      "displayDeleteBenefitModal",
      "display-screen",
      benefit
    );
    renderDeleteBenefitModal(benefit);
  } catch (e) {
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
